import React, { useEffect, useState } from "react";
import axios from "axios";
import configApi from "../../config";

const PatientStats = () => {
  const [patients, setPatients] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const token = localStorage.getItem("token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    fetchPatients();
  }, []);

  const fetchPatients = async () => {
    try {
      const response = await axios.get(
        `${configApi.apiEndpoint}/api/Patients`,
        config
      );
      setPatients(response.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="metric-card w-100">
        <div className="skeleton-circle"></div>
        <div className="metric-data gap-2">
          <div className="skeleton-box" style={{ width: '60px', height: '28px' }}></div>
          <div className="skeleton-box" style={{ width: '100px', height: '14px' }}></div>
        </div>
      </div>
    );
  }

  return (
    <div className="metric-card w-100">
      <div className="metric-icon">
        <i className="bi bi-people"></i>
      </div>
      <div className="metric-data">
        <h3>{patients.length}</h3>
        <span>Počet pacientov</span>
      </div>
    </div>
  );
};

export default PatientStats;
